import React, { useEffect, useState } from "react";
import "./TopSection.scss";
import Review from "../../Images/Review.png";
import Whatsapp from "../../Images/Whatsapp_icon.png";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EnquirePopup from "../EnquirePopup";




const TopSection = () => {
  const navigation = useNavigate()
    const [showPopup, setShowPopup] = useState(false);
     const [countryCode, setCountryCode] = useState("in");
  const resListinHandle = () =>{
    navigation("/places")
  }

  const OpneLinkHandle = () =>{
    window.open("https://app.businessbay.io/register", "_blank");
  }

  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

   useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json");
        const data = await res.json();
        setCountryCode(data?.country_code?.toLowerCase() || "in");
      } catch (err) {
        console.log("Could not fetch country. Defaulting to IN");
      }
    };
    fetchCountry();
  }, []);
  
  return (
    <Container>
        <Row className="top_section_main_wrapper">
        <Col md={6} className="main_wrapper">
          {/* <div className="whatsapp_order_wrapper"> */}
              {countryCode && countryCode == "in" ? (
            <a
              href="https://api.whatsapp.com/send/?phone=917835065469&text=Restaurant&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp_order_wrapper"
              style={{textDecoration:"none"}}
            >
              <div className="topsection_text_heading" >
                Get orders via WhatsApp
              </div>
              <div className="topsection_image_wrapper">
                <img src={Whatsapp} className="topsection_whatsappimg" />
              </div>
            </a>
          ) : (
            <a
              href="https://wa.me/971562198924"
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp_order_wrapper"
               style={{textDecoration:"none"}}
            >
              <div className="topsection_text_heading">
                Get orders via WhatsApp
              </div>
              <div className="topsection_image_wrapper">
                <img src={Whatsapp} className="topsection_whatsappimg" />
              </div>
            </a>
          )}
            {/* <div className="topsection_text_heading" >
              Get orders via WhatsApp
            </div>
            <div className="topsection_image_wrapper">
              <img src={Whatsapp} />
            </div> */}
          {/* </div> */}
          <div className="left_middle_wrapper">
            {/* <div className="steps_wrapper"> */}
            <div className="build_text">
                <h2>Launch Your Food App via <br/><span className="steps">3 Simple Steps!</span></h2>
            </div>
            {/* <div className="steps"></div> */}
            {/* </div> */}
            <div className="text_para">
            Turn your culinary dreams into reality with our easy-to-use application builder. Whether you're a gourmet restaurant or a fancy food truck, create and share a digital menu with customers and accept orders in minutes. 
            </div>
          </div>
          <div className="build_button_wrapper redbutton" 
          // onClick={OpneLinkHandle}
          onClick={handlePopup}
          >Create your app</div>
        </Col>
          <Col md={6} className="image_wrapper">
            <img src={Review} />
          </Col>
      </Row>
      {showPopup && (
       <EnquirePopup   open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
      )}
    </Container>
    // <div className="topsectiondiv">
      
    // </div>
  );
};

export default TopSection;
